// This is also called opaque types
export type Flavor<T, FlavorT> = T & { __TYPE__?: FlavorT };

export function isDefined<T>(x: T | null | undefined): x is T {
  return x !== null && x !== undefined;
}
